import React, {useEffect} from 'react';
import './timeline.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Timeline = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true, 
      easing: 'ease-out',
    });
  }, []);

  const events = [
    { title: "UBC Computer Science", role: "Undergraduate Teaching Assistant", description: 'Facilitated learning for CPSC 121 by leading lab sessions, tutorials, and office hours to assist students with complex programming and theoretical concepts.Fostered an engaging and supportive learning environment.', date: "Jan - April 2024", skills1:"Logic", skills2:"Communication", skills3:"Teamwork"},
    { title: "UBC Subbots", role: "Website Lead", description: 'Built and maintained the official UBC Subbots website using React.js, enhancing visibility for robotics projects and competition updates. Collaborated with a 30+ member team to deliver a responsive, scalable, and user-friendly design, while optimizing performance for speed, mobile access, and cross-browser compatibility.', date: "Nov 2024 - Present", skills1: "React.js", skills2: "Web Development", skills3: "Teamwork" },
    { title: "UBC Data Science Club", role: "UI/UX Developer", description: 'Redesigned the club’s digital platforms with a unified visual theme, improved accessibility, and a modern UI. Created wireframes, mockups, and prototypes in Figma, incorporating user feedback to refine designs. Simplified navigation and optimized layouts to enhance the experience for 200+ members, collaborating closely with a team of 10+ developers.', date: "Oct 2024 - Present", skills1: "Figma", skills2: "UI/UX Design", skills3: "Teamwork" },
    { title: "Wize Computing Academy", role:'Programming and Robotics Instructor', description: "I teach younger students the fundamentals of programming and robotics, aiming to spark curiosity and build a strong foundation in STEM. Through hands-on activities and approachable lessons, I help make complex concepts accessible and engaging, encouraging the next generation of tech enthusiasts.", date: "Sept - Dec 2024", skills1: "Robotics", skills2: "Communication" },
    { title: "Science Undergraduate Society of UBC", role: "Science RXN Coordinator", description: 'The Coordinators have the responsibility of organizing and executing events designed to welcome incoming UBC Science Students and to help integrate them into the UBC Science community and build relationships amongst themselves', date: "Jul - Sept 2024", skills1: "Teamwork", skills2:"Event Planning", skills3:"Communication" }
  ];

  return (
    <div className="timeline-container">
      <div className="timeline-line"></div>
      {events.map((event, index) => (
        <div className="timeline-wrapper" key={index}>
          <span className={`date-label ${index % 2 === 0 ? 'right-date' : 'left-date'}`}>
            {event.date}
          </span>
  
          <div
            className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}
            data-aos={index % 2 === 0 ? 'fade-right' : 'fade-left'}
          >
            <div className="card">
              <span className='title'>{event.title}</span>
              <span className="role">{event.role}</span>
              <span className='desc'>{event.description}</span>
              <div className='card-skills'>
                <span className='card-skill'>{event.skills1}</span>
                    {event.skills2 && (
                <span className='card-skill'>{event.skills2}</span>
                )}
                    {event.skills3 && (
                <span className='card-skill'>{event.skills3}</span>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
  
};

export default Timeline;

